<template>
  <div class="success-content">
    <div v-if="resultData && Object.keys(resultData).length > 0">
      <!-- 根据实际接口返回的数据结构展示结果 -->
      <div class="result-item result-title">
        该车辆属于召回范围
      </div>
      <div class="result-item" v-if="resultData.push_date">
        <span class="result-label">召回日期：</span>
        <span class="result-value">{{ resultData.push_date }}</span>
      </div>
      <div class="result-content">
        您的车辆已在比亚迪汽车召回名单。
        建议尽快联系就近4S店咨询检修事宜。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VinSuccessContent',
  props: {
    resultData: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped lang="less">
.success-content {
  width: 100%;

  .result-item {
    display: flex;
    align-items: center;
    .px2rem(margin-bottom, 8);
    .px2rem(font-size, 12);
    font-weight: 400;
    .px2rem(line-height, 18);
    &:last-child{
      .px2rem(margin-bottom, 12);
    }
  }
  .result-title{
    color: #E83010;
    font-weight: 500;
  }
  .result-label {
    color: #5C606A;
  }

  .result-value {
    color:#1A1D25;
  }
  .result-content{
    color:#1A1D25;
    .px2rem(font-size, 12);
    font-weight: 400;
    .px2rem(line-height, 18);
  }
}
</style>